import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FiHeart, FiStar, FiChevronDown, FiChevronUp, FiShoppingBag, FiShare2, FiTruck, FiRefreshCw, FiShield } from 'react-icons/fi';
import { addToCart } from '../store/cartSlice';
import { addToWishlist, removeFromWishlist } from '../store/wishlistSlice';
import { toast } from 'react-toastify';
import api from '../services/api';
import './ProductDetail.css';

const MOCK_DB = {
  1: { id: 1, name: 'Floral Print Maxi Dress', brand: 'Zara', price: 2499, originalPrice: 4999, imageEmoji: '👗', imageUrl: 'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=600&h=700&fit=crop&q=80', rating: 4.3, reviewCount: 128, sizes: ['XS','S','M','L','XL'], category: 'women', description: 'A beautiful floral print maxi dress perfect for any occasion. Made from premium quality fabric for ultimate comfort and style. Features a flattering silhouette with a flowing skirt.', material: '100% Viscose', fit: 'Regular Fit', washCare: 'Machine Wash Cold', colors: ['Red', 'Blue', 'Green', 'Black'], highlights: ['Floral Print', 'Maxi Length', 'V-Neck', 'Sleeveless', 'Zip Closure'], reviews: [{ id: 1, user: 'Priya S.', rating: 5, comment: 'Absolutely love this dress! Perfect fit and beautiful fabric.', date: '2025-01-15', verified: true }, { id: 2, user: 'Ananya M.', rating: 4, comment: 'Good quality, true to size. Would recommend!', date: '2025-01-10', verified: true }, { id: 3, user: 'Riya K.', rating: 4, comment: 'Beautiful dress, slightly long but overall great.', date: '2024-12-28', verified: false }] },
  2: { id: 2, name: 'Slim Fit Cotton Shirt', brand: 'H&M', price: 1299, originalPrice: 2599, imageEmoji: '👔', imageUrl: 'https://images.unsplash.com/photo-1594938298603-c8148c4b4415?w=600&h=700&fit=crop&q=80', rating: 4.1, reviewCount: 89, sizes: ['S','M','L','XL','XXL'], colors: ['Blue','White','Pink'], category: 'men', description: 'Classic slim fit cotton shirt for everyday elegance. Perfect for office and casual occasions.', material: '100% Cotton', fit: 'Slim Fit', washCare: 'Machine Wash Cold', highlights: ['Slim Fit', '100% Cotton', 'Button-Down Collar', 'Full Sleeves'], reviews: [{ id: 1, user: 'Rahul M.', rating: 4, comment: 'Great quality shirt. Fits perfectly.', date: '2025-01-20', verified: true }] },
  3: { id: 3, name: 'High Waist Denim Jeans', brand: "Levi's", price: 3499, originalPrice: 5999, imageEmoji: '👖', imageUrl: 'https://images.unsplash.com/photo-1542272604-787c3835535d?w=600&h=700&fit=crop&q=80', rating: 4.5, reviewCount: 234, sizes: ['28','30','32','34','36'], colors: ['Blue','Black','Grey'], category: 'men', description: 'Premium stretch denim jeans with classic high-waist design. Durable and stylish for all occasions.', material: '98% Cotton 2% Elastane', fit: 'Straight Fit', washCare: 'Machine Wash Cold', highlights: ['High Waist', 'Straight Fit', 'Stretch Denim', '5-Pocket Design'], reviews: [{ id: 1, user: 'Arjun P.', rating: 5, comment: 'Best jeans I have ever bought!', date: '2025-01-18', verified: true }, { id: 2, user: 'Karan S.', rating: 4, comment: 'Very comfortable and durable.', date: '2025-01-05', verified: true }] },
  5: { id: 5, name: 'Running Sports Shoes', brand: 'Nike', price: 4999, originalPrice: 8999, imageEmoji: '👟', imageUrl: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=600&h=700&fit=crop&q=80', rating: 4.6, reviewCount: 312, sizes: ['6','7','8','9','10','11'], colors: ['Black','White','Blue','Red'], category: 'men', description: 'High-performance running shoes with superior cushioning. Perfect for daily runs and gym workouts.', material: 'Synthetic Mesh', fit: 'Standard', washCare: 'Wipe Clean', highlights: ['Air Cushion Sole', 'Breathable Mesh Upper', 'Anti-Slip', 'Lightweight'], reviews: [{ id: 1, user: 'Vijay R.', rating: 5, comment: 'Amazing shoes, great for running!', date: '2025-01-22', verified: true }] },
  11: { id: 11, name: 'Formal Blazer', brand: 'Van Heusen', price: 3999, originalPrice: 7999, imageEmoji: '🧥', imageUrl: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=700&fit=crop&q=80', rating: 4.5, reviewCount: 89, sizes: ['S','M','L','XL','XXL'], colors: ['Navy','Charcoal','Black','Grey'], category: 'men', description: 'Sharp formal blazer for the modern professional. Perfect for office and formal occasions.', material: 'Poly Viscose', fit: 'Slim Fit', washCare: 'Dry Clean Only', highlights: ['Slim Fit', '2-Button', 'Notch Lapel', 'Single Vent'], reviews: [{ id: 1, user: 'Manish K.', rating: 5, comment: 'Excellent quality blazer, looks very professional.', date: '2025-01-10', verified: true }] },
};

const MOCK = MOCK_DB[1];

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(s => s.auth);
  const wishlistItems = useSelector(s => s.wishlist.items);

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedColor, setSelectedColor] = useState('');
  const [qty] = useState(1);
  const [activeImage, setActiveImage] = useState(0);
  const [showSizeGuide, setShowSizeGuide] = useState(false);
  const [sizeError, setSizeError] = useState(false);
  const [expandedSection, setExpandedSection] = useState({ desc: true, details: false, returns: false });
  const [pincode, setPincode] = useState('');
  const [pincodeMsg, setPincodeMsg] = useState('');

  const isWishlisted = wishlistItems.some(i => i.id === product?.id);

  useEffect(() => {
    api.get(`/api/products/${id}`)
      .then(res => { setProduct(res.data); setSelectedColor(res.data.colors?.[0] || ''); })
      .catch(() => {
        const mock = MOCK_DB[Number(id)] || MOCK;
        setProduct(mock);
        setSelectedColor(mock.colors?.[0] || '');
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleAddToCart = () => {
    if (!isAuthenticated) { navigate('/login'); return; }
    if (!selectedSize) { setSizeError(true); toast.error('Please select a size'); return; }
    dispatch(addToCart({ ...product, quantity: qty, selectedSize, selectedColor }));
    toast.success('Added to bag!');
    setSizeError(false);
  };

  const handleBuyNow = () => {
    if (!isAuthenticated) { navigate('/login'); return; }
    if (!selectedSize) { setSizeError(true); toast.error('Please select a size'); return; }
    dispatch(addToCart({ ...product, quantity: qty, selectedSize, selectedColor }));
    navigate('/checkout');
  };

  const handleWishlist = () => {
    if (!isAuthenticated) { navigate('/login'); return; }
    if (isWishlisted) { dispatch(removeFromWishlist(product.id)); toast.info('Removed from wishlist'); }
    else { dispatch(addToWishlist(product)); toast.success('Added to wishlist!'); }
  };

  const checkPincode = () => {
    if (pincode.length === 6) setPincodeMsg('✅ Delivery available in 3-5 business days');
    else setPincodeMsg('❌ Please enter a valid 6-digit pincode');
  };

  const discount = product?.originalPrice
    ? Math.round((1 - product.price / product.originalPrice) * 100) : 0;

  const images = product?.imageUrl
    ? [product.imageUrl, product.imageUrl + '&sat=-30', product.imageUrl + '&bri=10']
    : [product?.imageEmoji || '👗'];
  const isPhotoImages = !!product?.imageUrl;

  if (loading) return <div className="loading-wrapper" style={{ paddingTop: 100 }}><div className="spinner" /><p>Loading product...</p></div>;
  if (!product) return <div className="empty-state" style={{ paddingTop: 100 }}><h2>Product not found</h2><Link to="/products" className="btn btn-primary">Browse Products</Link></div>;

  return (
    <div className="product-detail-page">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <Link to="/">Home</Link><span>/</span>
        <Link to={`/products/${product.category}`}>{product.category}</Link><span>/</span>
        <span>{product.brand}</span><span>/</span>
        <span>{product.name}</span>
      </div>

      <div className="pd-layout">
        {/* Left: Images */}
        <div className="pd-images">
          <div className="pd-thumbs">
            {images.map((img, i) => (
              <button key={i} className={`pd-thumb${activeImage === i ? ' active' : ''}`} onClick={() => setActiveImage(i)}>
                {isPhotoImages
                  ? <img src={img} alt={`view ${i+1}`} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 4 }} />
                  : <span style={{ fontSize: 32 }}>{img}</span>
                }
              </button>
            ))}
          </div>
          <div className="pd-main-image">
            <div className="pd-image-display">
              {isPhotoImages
                ? <img src={images[activeImage]} alt={product.name} className="pd-main-photo" />
                : <span className="pd-main-emoji">{images[activeImage]}</span>
              }
            </div>
            {discount > 0 && <div className="pd-discount-badge">{discount}% OFF</div>}
            <button className="pd-share-btn"><FiShare2 /></button>
          </div>
        </div>

        {/* Right: Info */}
        <div className="pd-info">
          <div className="pd-brand-row">
            <Link to={`/products?brand=${product.brand}`} className="pd-brand">{product.brand}</Link>
            <button className={`pd-wishlist-btn${isWishlisted ? ' active' : ''}`} onClick={handleWishlist}>
              <FiHeart /> {isWishlisted ? 'Wishlisted' : 'Wishlist'}
            </button>
          </div>

          <h1 className="pd-name">{product.name}</h1>

          {/* Rating */}
          {product.rating && (
            <div className="pd-rating-row">
              <span className="pd-rating-badge"><FiStar /> {product.rating}</span>
              <span className="pd-review-count">{product.reviewCount} Ratings & Reviews</span>
            </div>
          )}

          <hr className="pd-divider" />

          {/* Price */}
          <div className="pd-price-section">
            <div className="pd-price-row">
              <span className="pd-price">₹{product.price?.toLocaleString()}</span>
              {product.originalPrice && <span className="pd-original">₹{product.originalPrice?.toLocaleString()}</span>}
              {discount > 0 && <span className="pd-off">({discount}% OFF)</span>}
            </div>
            <p className="pd-tax-note">inclusive of all taxes</p>
          </div>

          {/* Colors */}
          {product.colors?.length > 0 && (
            <div className="pd-section">
              <p className="pd-section-title">COLOR: <span className="pd-selected-val">{selectedColor}</span></p>
              <div className="pd-colors">
                {product.colors.map(c => (
                  <button
                    key={c}
                    className={`pd-color-btn${selectedColor === c ? ' active' : ''}`}
                    onClick={() => setSelectedColor(c)}
                  >
                    <span className="pd-color-dot" style={{ background: c.toLowerCase() === 'nude' ? '#E8C9A0' : c.toLowerCase() }} />
                    {c}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Size */}
          <div className="pd-section">
            <div className="pd-size-header">
              <p className="pd-section-title">SELECT SIZE {selectedSize && <span className="pd-selected-val">{selectedSize}</span>}</p>
              <button className="pd-size-guide-btn" onClick={() => setShowSizeGuide(!showSizeGuide)}>SIZE GUIDE</button>
            </div>
            {sizeError && <p className="pd-size-error">Please select a size to continue</p>}
            <div className="pd-sizes">
              {product.sizes?.map(s => (
                <button
                  key={s}
                  className={`pd-size-btn${selectedSize === s ? ' active' : ''}`}
                  onClick={() => { setSelectedSize(s); setSizeError(false); }}
                >
                  {s}
                </button>
              ))}
            </div>
            {showSizeGuide && (
              <div className="size-guide-modal">
                <div className="size-guide-content">
                  <div className="sg-header"><h3>Size Guide</h3><button onClick={() => setShowSizeGuide(false)}>✕</button></div>
                  <table className="sg-table">
                    <thead><tr><th>Size</th><th>Chest (in)</th><th>Waist (in)</th><th>Hip (in)</th></tr></thead>
                    <tbody>
                      <tr><td>XS</td><td>32-33</td><td>24-25</td><td>34-35</td></tr>
                      <tr><td>S</td><td>34-35</td><td>26-27</td><td>36-37</td></tr>
                      <tr><td>M</td><td>36-37</td><td>28-29</td><td>38-39</td></tr>
                      <tr><td>L</td><td>38-40</td><td>30-32</td><td>40-42</td></tr>
                      <tr><td>XL</td><td>41-43</td><td>33-35</td><td>43-45</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>

          {/* CTA Buttons */}
          <div className="pd-cta-row">
            <button className="pd-bag-btn" onClick={handleAddToCart}><FiShoppingBag /> ADD TO BAG</button>
            <button className="pd-buy-btn" onClick={handleBuyNow}>BUY NOW</button>
          </div>

          {/* Delivery */}
          <div className="pd-delivery">
            <p className="pd-section-title">DELIVERY OPTIONS</p>
            <div className="pd-pincode-row">
              <input type="text" placeholder="Enter Pincode" value={pincode} onChange={e => setPincode(e.target.value.replace(/\D/,'').slice(0,6))} maxLength={6} />
              <button onClick={checkPincode}>Check</button>
            </div>
            {pincodeMsg && <p className="pd-pincode-msg">{pincodeMsg}</p>}
            <div className="pd-delivery-info">
              <div className="pd-delivery-item"><FiTruck /><span>Free delivery on orders above ₹499</span></div>
              <div className="pd-delivery-item"><FiRefreshCw /><span>Easy 30 day returns & exchanges</span></div>
              <div className="pd-delivery-item"><FiShield /><span>Try & Buy available</span></div>
            </div>
          </div>

          <hr className="pd-divider" />

          {/* Product Description */}
          <AccordionSection title="PRODUCT DETAILS" expanded={expandedSection.desc} onToggle={() => setExpandedSection(p => ({ ...p, desc: !p.desc }))}>
            <p className="pd-description">{product.description}</p>
            {product.highlights && (
              <ul className="pd-highlights">
                {product.highlights.map(h => <li key={h}>• {h}</li>)}
              </ul>
            )}
            <div className="pd-specs">
              {product.material && <div className="pd-spec"><span>Material</span><span>{product.material}</span></div>}
              {product.fit && <div className="pd-spec"><span>Fit</span><span>{product.fit}</span></div>}
              {product.wash && <div className="pd-spec"><span>Wash Care</span><span>{product.wash}</span></div>}
            </div>
          </AccordionSection>

          <AccordionSection title="RATINGS & REVIEWS" expanded={expandedSection.details} onToggle={() => setExpandedSection(p => ({ ...p, details: !p.details }))}>
            <div className="pd-reviews">
              <div className="pd-rating-summary">
                <div className="pd-big-rating">{product.rating}<span>/5</span></div>
                <div className="pd-rating-bars">
                  {[5,4,3,2,1].map(star => (
                    <div key={star} className="pd-rating-bar-row">
                      <span>{star}★</span>
                      <div className="pd-bar"><div className="pd-bar-fill" style={{ width: star === 5 ? '60%' : star === 4 ? '25%' : star === 3 ? '10%' : star === 2 ? '3%' : '2%', background: star >= 4 ? 'var(--huge-green)' : star === 3 ? 'var(--huge-gold)' : 'var(--huge-pink)' }} /></div>
                    </div>
                  ))}
                </div>
              </div>
              {product.reviews?.map(r => (
                <div key={r.id} className="pd-review-card">
                  <div className="pd-review-header">
                    <span className={`pd-review-rating ${r.rating >= 4 ? 'good' : r.rating === 3 ? 'ok' : 'bad'}`}>{'★'.repeat(r.rating)}</span>
                    {r.verified && <span className="pd-verified">✓ Verified Purchase</span>}
                  </div>
                  <p className="pd-review-comment">{r.comment}</p>
                  <p className="pd-review-meta">{r.user} · {r.date}</p>
                </div>
              ))}
            </div>
          </AccordionSection>

          <AccordionSection title="RETURN & EXCHANGE POLICY" expanded={expandedSection.returns} onToggle={() => setExpandedSection(p => ({ ...p, returns: !p.returns }))}>
            <div className="pd-policy">
              <p>✓ Easy 30-day return policy</p>
              <p>✓ Free returns on all orders</p>
              <p>✓ Exchange available for different size/color</p>
              <p>✓ Refund processed within 5-7 business days</p>
            </div>
          </AccordionSection>
        </div>
      </div>
    </div>
  );
}

function AccordionSection({ title, expanded, onToggle, children }) {
  return (
    <div className="pd-accordion">
      <button className="pd-accordion-header" onClick={onToggle}>
        <span>{title}</span>
        {expanded ? <FiChevronUp /> : <FiChevronDown />}
      </button>
      {expanded && <div className="pd-accordion-body">{children}</div>}
    </div>
  );
}
